
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import Enums from '@/lib/enums'
    import { GetPrintWorld } from '@/common/js/PrintWorld'
    import UpdateOderStatu from './update-stockorder-status.vue'
    import UpdatebackstockorderStatu from '@/store/entities/back-updatestatus'
    import moment from 'moment'
    import appconst from '@/lib/appconst';

    // 扫描记录接口
    interface ScanRecord {
        id: string;
        productId: number;
        productNo: string;
        productSku: string;
        productName: string;
        scanCount: number;
        lastScanTime: string;
        productImgGuid: string;
    }

    // 推荐订单接口
    interface RecommendOrder {
        orderId: number;
        orderNumber: string;
        products: any[];
        sameProductCount: number;
        totalProductCount: number;
        remainingCount: number;
        totalRemainingAll: number;
        currentProductNeedCount: number;
        currentProductScannedCount: number;
        sortPriority: number;
        priorityText: string;
    }

    @Component({
        name: "backstockorderbatchpack",
        components: { UpdateOderStatu }
    })
    export default class BackStockBatchPack extends AbpBase {
        // 路由参数
        batchId: number = 0;
        batchNumber: string = '';

        // 统计数据
        totalCount: number = 0;
        packedCount: number = 0;
        unpackedCount: number = 0;

        // 扫描相关
        scanBarcode: string = '';
        scanRecords: ScanRecord[] = [];
        recommendOrders: RecommendOrder[] = [];

        // 订单列表
        orderList: any[] = [];
        loading: boolean = false;

        // 打印相关
        isPdfData: boolean = true;
        needCert: boolean = true;
        automaticJump: boolean = false;
        printerList: string[] = [];
        selectedPrinter: string = '';
        isLoadPrintList: boolean = false;

        // 异常弹窗
        updateOderStatuShow: boolean = false;
        currentAbnormalOrder: any = null;


        lastScanBarcode: string = '';
        lastScanTime: number = 0;
        scanLock: boolean = false; // 加这个锁

        // 扫描表格列
        scanColumns = [
            {
                title: '商品编码',
                key: 'productNo',
                width: 200
            },
            {
                title: '产品内码',
                key: 'productId',
                width: 100
            },
            {
                title: 'Sku信息',
                key: 'productSku',
                minWidth: 100
            },
            {
                title: '商品图片',
                width: 80,
                align: 'center',
                render: (h: any, params: any) => {
                    // 获取图片URL
                    let imgUrl = '';
                    const product = params.row;
                    if (product && product.productImgGuid) {
                        if (product.productImgGuid.indexOf('http') === 0 || product.productImgGuid.indexOf('https') === 0) {
                            imgUrl = product.productImgGuid;
                        } else {
                            const data = { imageGuid: product.productImgGuid, url: null };
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            imgUrl = data.url;
                        }
                    }

                    return h('div', {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }
                    }, [
                        imgUrl ? h('img', {
                            style: {
                                width: '40px',
                                height: '40px',
                                objectFit: 'cover',
                                border: '1px solid #f0f0f0',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            },
                            attrs: {
                                src: imgUrl,
                                preview: 'scan_' + params.row.productId,
                                'preview-text': params.row.productNo || params.row.productSku
                            }
                        }) : h('div', {
                            style: {
                                width: '40px',
                                height: '40px',
                                background: '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#999',
                                fontSize: '12px',
                                border: '1px solid #f0f0f0',
                                borderRadius: '4px'
                            }
                        }, '无图')
                    ]);
                }
            },
            {
                title: '扫描数量',
                key: 'scanCount',
                width: 200,
                render: (h: any, params: any) => {
                    return h('div', [
                        h('InputNumber', {
                            props: {
                                value: params.row.scanCount,
                                min: 0,
                                size: 'small'
                            },
                            style: {
                                width: '80px',
                                marginRight: '5px'
                            },
                            on: {
                                'on-change': (value: number) => {
                                    this.updateScanCount(params.row, value);
                                }
                            }
                        }),
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small',
                                icon: 'md-trash'
                            },
                            style: {
                                marginLeft: '5px'
                            },
                            on: {
                                click: () => {
                                    this.deleteScanRecord(params.row);
                                }
                            }
                        })
                    ]);
                }
            },
            {
                title: '最后扫描时间',
                key: 'lastScanTime',
                width: 160,
                render: (h: any, params: any) => {
                    return h('span', moment(params.row.lastScanTime).format('YYYY-MM-DD HH:mm:ss'));
                }
            }
        ];

        // 推荐订单表格列
        recommendColumns = [
            {
                title: '订单编号',
                key: 'orderNumber',
                width: 180,
                fixed: 'left'
            },
            {
                title: '商品信息',
                minWidth: 400,
                render: (h: any, params: any) => {
                    return h('div', [
                        h('ul', {
                            style: {
                                listStyle: 'none',
                                margin: 0,
                                padding: 0
                            }
                        }, params.row.products.map((item: any) => {
                            // 根据是否扫描过设置不同样式
                            const itemStyle = {
                                fontSize: '12px',
                                lineHeight: '28px',
                                borderBottom: '1px dashed #e8e8e8',
                                padding: '0 5px',
                                backgroundColor: item.isScanned ? '#f0f9eb' : 'transparent',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            };

                            return h('li', {
                                style: itemStyle,
                                attrs: {
                                    title: `${item.productNo || ''} 内码:${item.productId} 数量:${item.scannedCount}/${item.needCount}${item.shelfPosition ? ' 货架:' + item.shelfPosition : ''}`
                                }
                            }, [
                                // 商品编码
                                item.productNo ? h('span', item.productNo + ' ') : null,

                                // 内码（红色显示）
                                h('span', {
                                    style: {
                                        color: '#ed4014',
                                        fontWeight: 'bold'
                                    }
                                }, `[${item.productId}]`),

                                // 数量显示 已扫/需要
                                h('span', {
                                    style: {
                                        marginLeft: '8px',
                                        color: item.isScanned ? (item.remaining === 0 ? '#19be6b' : '#ed4014') : '#666'
                                    }
                                }, `${item.scannedCount}/${item.needCount}`),

                                // 货架位置
                                item.shelfPosition ? h('span', {
                                    style: {
                                        marginLeft: '8px',
                                        color: '#2d8cf0'
                                    }
                                }, `货:${item.shelfPosition}`) : null
                            ]);
                        }))
                    ]);
                }
            },
            {
                title: '匹配信息',
                width: 200,
                render: (h: any, params: any) => {
                    const scannedCount = params.row.products.filter((p: any) => p.isScanned).length;

                    return h('div', [
                        h('Tag', {
                            props: {
                                color: params.row.sortPriority <= 1 ? 'success' : (params.row.sortPriority === 2 ? 'warning' : 'primary')
                            }
                        }, params.row.priorityText),
                        h('div', {
                            style: {
                                marginTop: '4px',
                                fontSize: '12px'
                            }
                        }, `剩余:${params.row.totalRemainingAll}`)
                    ]);
                }
            }
        ];

        // 订单表格列
        orderColumns = [
            //{
            //    type: 'selection',
            //    width: 60,
            //    align: 'center',
            //},
            {
                title: '订单编号',
                key: 'orderNumber',
                width: 170,
               // fixed: 'left'
            },
            {
                title: '运单号',
                key: 'tradeNo',
                width: 150
            },
            {
                title: '产品信息',
                minWidth: 400,
                render: (h: any, params: any) => {
                    return h('div', [
                        h('ul', params.row.productInfos.map((item: any) => {
                            const scanned = this.getProductScannedCount(item.productId);
                            const isComplete = scanned >= item.count;

                            // 获取图片URL - 修复图片显示
                            let imgUrl = '';
                            if (item.productImgGuid) {
                                // 判断是否是完整URL（包含http）
                                if (item.productImgGuid.indexOf('http') === 0 || item.productImgGuid.indexOf('https') === 0) {
                                    imgUrl = item.productImgGuid;  // 直接使用完整URL
                                } else {
                                    // 如果是GUID，调用接口获取URL
                                    const data = { imageGuid: item.productImgGuid, url: null };
                                    this.$store.commit('expressuserinfo/getImgUrl', data);
                                    imgUrl = data.url;
                                }
                            }

                            return h('li', {
                                style: {
                                    fontSize: '12px',
                                    lineHeight: '30px',
                                    borderBottom: '1px dashed #e8e8e8',
                                    padding: '5px 0',
                                    display: 'flex',
                                    alignItems: 'center'
                                }
                            }, [
                                // 商品图片
                                imgUrl ? h('img', {
                                    style: {
                                        width: '40px',
                                        height: '40px',
                                        marginRight: '10px',
                                        objectFit: 'cover',
                                        border: '1px solid #f0f0f0',
                                        borderRadius: '4px'
                                    },
                                    attrs: {
                                        src: imgUrl,
                                        preview: 'product_' + item.productId,
                                        'preview-text': item.productNo || item.productSku
                                    },
                                    on: {
                                        click: (e: any) => {
                                            e.stopPropagation();
                                        }
                                    }
                                }) : h('div', {
                                    style: {
                                        width: '40px',
                                        height: '40px',
                                        marginRight: '10px',
                                        background: '#f5f5f5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#999',
                                        fontSize: '12px',
                                        border: '1px solid #f0f0f0',
                                        borderRadius: '4px'
                                    }
                                }, '无图'),

                                // 商品信息
                                h('div', {
                                    style: {
                                        flex: 1
                                    }
                                }, [
                                    h('div', {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '2px',
                                            flexWrap: 'wrap'
                                        }
                                    }, [
                                        h('span', {
                                            style: {
                                                fontWeight: 'bold',
                                                marginRight: '15px',
                                                color: '#333'
                                            }
                                        }, `商品编码: ${item.productNo || ''}`),
                                        h('span', {
                                            style: {
                                                color: '#ff9900',
                                                fontWeight: 'bold',
                                                marginRight: '15px'
                                            }
                                        }, `产品内码: ${item.productId}`),
                                        item.productSku ? h('span', {
                                            style: {
                                                color: '#2d8cf0'
                                            }
                                        }, `SKU: ${item.productSku}`) : null
                                    ]),
                                    h('div', {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexWrap: 'wrap'
                                        }
                                    }, [
                                        h('span', {
                                            style: {
                                                marginRight: '15px',
                                                color: '#19be6b',
                                                fontWeight: 'bold'
                                            }
                                        }, `数量: ${item.count}`),
                                        h('span', {
                                            style: {
                                                color: isComplete ? '#19be6b' : '#ed4014',
                                                fontWeight: 'bold',
                                                marginRight: '15px'
                                            }
                                        }, `已扫: ${scanned}/${item.count}`),
                                        item.shelfPosition ? h('span', {
                                            style: {
                                                color: '#2d8cf0'
                                            }
                                        }, `货架: ${item.shelfPosition}`) : null
                                    ])
                                ])
                            ]);
                        }))
                    ]);
                }
            },
            {
                title: '状态',
                width: 100,
                render: (h: any, params: any) => {
                    let statusText = '';
                    let statusColor = '';

                    if (params.row.packageStatus === 4) {
                        statusText = '已出仓';
                        statusColor = 'success';
                    } else if (this.isOrderComplete(params.row)) {
                        statusText = '可打包';
                        statusColor = 'warning';
                    } else {
                        const status = Enums.WarehouseOrderPackageStatus.find((item: any) => item.value === params.row.packageStatus);
                        statusText = status ? status.name : '未知';
                        statusColor = 'default';
                    }

                    return h('Tag', {
                        props: {
                            color: statusColor
                        }
                    }, statusText);
                }
            },
            {
                title: '打包时间',
                key: 'packedTime',
                width: 160,
                render: (h: any, params: any) => {
                    return h('span', params.row.packedTime ? moment(params.row.packedTime).format('YYYY-MM-DD HH:mm:ss') : '-');
                }
            },
            {
                title: '操作',
                width: 220,
                fixed: 'right',
                render: (h: any, params: any) => {
                    const isPacked = (params.row.packageStatus === 4 || params.row.packageStatus === 2);
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                                disabled: false  // 打印面单按钮永远可用
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.printOrderPdf(params.row);
                                }
                            }
                        }, '打印面单'),
                        h('Button', {
                            props: {
                                type: 'info',
                                size: 'small',
                                disabled: false  // 浏览面单按钮永远可用
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.viewOrderPdf(params.row);
                                }
                            }
                        }, '浏览面单'),
                        h('Button', {
                            props: {
                                type: 'success',
                                size: 'small',
                                disabled: isPacked || !this.isOrderComplete(params.row)
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.completeOrderPack(params.row);
                                }
                            }
                        }, '完成打包'),
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small',
                                disabled: isPacked
                            },
                            on: {
                                click: () => {
                                    this.markOrderAbnormal(params.row);
                                }
                            }
                        }, '标记异常')
                    ]);
                }
            }
        ];

        viewOrderPdf(order: any) {
            // 获取PDF URL
            const pdfData = this.getPdfUrl(order);

            if (pdfData.url) {
                // 在新窗口打开PDF链接
                window.open(pdfData.url, '_blank');
            } else {
                this.$Message.error('无法获取面单链接');
            }
        }

        async created() {
            // 获取路由参数
            this.batchNumber = this.$route.params.batchName as string || '';
            await this.loadPrinterList();
            if (this.batchNumber) {
                await this.getOrderList();
                this.focusScanInput();

            } else {
                this.focusScanOrderInput();
            }
        }

        // 监听路由参数变化
        @Watch('$route.params.batchName')
        async onBatchNumberChange(newVal: string) {
            if (newVal && this.$store.state.backPackingBatch.isRedirect) {
                this.$store.state.backPackingBatch.isRedirect = false;
                this.batchNumber = newVal;
                this.scanRecords = [];
                this.recommendOrders = [];
                await this.getOrderList();
                this.focusScanInput();
            }
        }

        // 搜索批次（回车或点击按钮触发）
        async searchBatch() {
            if (!this.batchNumber || !this.batchNumber.trim()) {
                this.$Message.warning('请输入批次号');
                return;
            }

            if (!this.isLoadPrintList) {
                await this.loadPrinterList();
            }

            // 2. 加载完了，但没选打印机 → 提示
            if (!this.selectedPrinter) {
                this.$Modal.warning({
                    title: '提示',
                    content: '请先选择打印机',
                    okText: '确定'
                });
                return;
            }
            // 清空扫描记录
            this.scanRecords = [];
            this.recommendOrders = [];
            this.orderList = [];
            this.totalCount = 0;
            this.packedCount = 0;
            this.unpackedCount = 0;

            // 更新路由参数（不刷新页面）
            this.$router.replace({
                name: 'backstockorderbatchpack',
                params: {
                    batchName: this.batchNumber.trim()
                }
            });

            // 加载批次信息
            await this.getOrderList();

            // 重新聚焦扫描框
            this.focusScanInput();
        }

        // 获取订单列表
        async getOrderList() {
            this.loading = true;
            try {
                const result = await this.$store.dispatch('backStockOrderBatch/getBatchStockOrderList', {
                    data: {
                        batchName: this.batchNumber,
                        isBox: false
                    }
                });

               // ========== 测试用：强制所有订单为未打包状态 ==========
                //let orderListData = (result || []).map(order => ({
                //    ...order,
                //    packageStatus: 0,  // 强制设为未打包
                //    packedTime: null   // 清空打包时间
                //}));
                // ================================================


                // 处理排序：已打包的放前面，按打包时间倒序
                this.orderList = (result || []).sort((a: any, b: any) => {
                    if (a.packedTime && !b.packedTime) return -1;
                    if (!a.packedTime && b.packedTime) return 1;
                    if (a.packedTime && b.packedTime) {
                        return new Date(b.packedTime).getTime() - new Date(a.packedTime).getTime();
                    }
                    return 0;
                });

                // 计算统计数据
                this.totalCount = this.orderList.length;
                this.packedCount = this.orderList.filter((o: any) => o.packageStatus === 4 || o.packageStatus === 2).length;
                this.unpackedCount = this.totalCount - this.packedCount;
            } catch (error) {
                this.$Message.error('获取订单列表失败');
            } finally {
                this.loading = false;
            }
        }

        // 获取商品已扫描数量
        getProductScannedCount(productId: number): number {
            const record = this.scanRecords.find(r => r.productId === productId);
            return record ? record.scanCount : 0;
        }

        // 处理扫描
        async handleScan() {
            // ========== 【全局锁：防止瞬间并发重复触发】最强防重复 ==========
            if (this.scanLock) {
                this.scanBarcode = '';
                this.focusScanInput();
                return;
            }
            this.scanLock = true; // 上锁
            try {
                if (!this.scanBarcode) return;

                //if (!this.selectedPrinter) {
                //    this.$Message.warning({
                //        content: '请先选择打印机',
                //        duration: 3
                //    });
                //    return;
                //}
                // 1. 根据商品编码找到商品信息
                this.scanBarcode = this.scanBarcode.trim().toUpperCase();
                const now = Date.now();

                const product = this.findProductByBarcode(this.scanBarcode);
                if (!product) {
                    this.$Message.error('未找到该商品编码');
                    this.scanBarcode = '';
                    this.focusScanInput();
                    return;
                }

                // 2秒内重复有效扫描 → 直接拦截
                if (this.scanBarcode === this.lastScanBarcode && now - this.lastScanTime < 1500) {
                    await this.$store.dispatch('backStockOrderBatch/addScan', {
                        batchId: this.orderList[0].batchId,
                        productNo: this.scanBarcode,
                        isEnable: false
                    });

                    this.scanBarcode = '';
                    this.focusScanInput();
                    return;
                } else {
                    this.lastScanBarcode = this.scanBarcode;
                    this.lastScanTime = now;
                    await this.$store.dispatch('backStockOrderBatch/addScan', {
                        batchId: this.orderList[0].batchId,
                        productNo: this.scanBarcode,
                        isEnable: true
                    });
                }


                // 2. 更新扫描记录
                const existingRecord = this.scanRecords.find(r => r.productId === product.productId);
                if (existingRecord) {
                    existingRecord.scanCount += 1;
                    existingRecord.lastScanTime = new Date().toISOString();
                } else {
                    this.scanRecords.push({
                        id: `scan_${Date.now()}_${Math.random()}`,
                        productId: product.productId,
                        productNo: product.productNo,
                        productSku: product.productSku,
                        productName: product.productName,
                        productImgGuid: product.productImgGuid,
                        scanCount: 1,
                        lastScanTime: new Date().toISOString()
                    });
                }

                // 3. 检查是否有订单可以打包
                const matchedOrder = this.findMatchOrder();
                if (matchedOrder) {
                    this.$Message.success(`订单 ${matchedOrder.orderNumber} 已凑齐，正在打印面单...`);
                    await this.completeOrderPack(matchedOrder);
                } else {
                    // 4. 计算推荐订单
                    this.calculateRecommendOrders();
                    this.$Message.success('扫描成功');
                }

                this.scanBarcode = '';
                this.focusScanInput();
            } finally {
                this.scanLock = false;
            }
        }

        // 根据条码查找商品
        findProductByBarcode(barcode: string) {
            for (const order of this.orderList) {
                if (order.packageStatus === 4 || order.packageStatus === 2) continue; // 已打包的跳过
                const product = order.productInfos.find((p: any) =>
                    p.productNo === barcode
                );
                if (product) return product;
            }
            return null;
        }

        // 查找可以打包的订单
        findMatchOrder() {
            for (const order of this.orderList) {
                if (order.packageStatus === 4 || order.packageStatus === 2) continue;

                let allMatched = true;
                for (const product of order.productInfos || []) {
                    const scanned = this.getProductScannedCount(product.productId);
                    if (scanned < product.count) {
                        allMatched = false;
                        break;
                    }
                }

                if (allMatched) {
                    return order;
                }
            }
            return null;
        }

        // 计算推荐订单
        calculateRecommendOrders() {
            if (this.scanRecords.length === 0) {
                this.recommendOrders = [];
                return;
            }

            // 获取所有未打包订单（packageStatus !== 4）
            const unpackedOrders = this.orderList.filter(o => o.packageStatus !== 4);

       //     const unpackedOrders = this.orderList;

            const orderPriorities: RecommendOrder[] = [];

            for (const order of unpackedOrders) {
                // 检查订单是否包含所有扫描的商品，且数量足够
                let containsAllScanned = true;
                const matchedProducts = [];

                for (const scan of this.scanRecords) {
                    // 在订单中查找这个商品
                    const product = order.productInfos.find((p: any) => p.productNo === scan.productNo);

                    // 如果订单中没有这个商品，或者订单的需求量小于扫描数量，则不符合
                    if (!product || product.count < scan.scanCount) {
                        containsAllScanned = false;
                        break;
                    }

                    matchedProducts.push({
                        ...product,
                        scannedCount: scan.scanCount,
                        needCount: product.count,
                        remaining: product.count - scan.scanCount
                    });
                }

                // 必须包含所有扫描的商品且数量足够
                if (!containsAllScanned) continue;

                // 获取订单中所有商品的信息
                const allProducts = [];
                let totalRemainingAll = 0;

                for (const product of order.productInfos || []) {
                    const scanRecord = this.scanRecords.find(r => r.productNo === product.productNo);
                    const scanned = scanRecord ? scanRecord.scanCount : 0;
                    const remaining = product.count - scanned;

                    allProducts.push({
                        ...product,
                        scannedCount: scanned,
                        needCount: product.count,
                        remaining: remaining,
                        isScanned: scanRecord !== undefined
                    });

                    totalRemainingAll += remaining;
                }

                // 确定优先级
                let sortPriority = 3;
                let priorityText = '其他';

                // 检查匹配的商品是否都已扫够数量
                const allMatchedSatisfied = matchedProducts.every(mp => mp.remaining === 0);

                if (allMatchedSatisfied) {
                    // 如果所有扫描的商品都已扫够
                    if (totalRemainingAll === 0) {
                        sortPriority = 1;
                        priorityText = '可打包';
                    } else {
                        sortPriority = 2;
                        priorityText = '当前商品已够';
                    }
                } else {
                    // 还有扫描的商品没扫够
                    sortPriority = 3;
                    priorityText = '当前商品未够';
                }

                orderPriorities.push({
                    orderId: order.id,
                    orderNumber: order.orderNumber,
                    products: allProducts,
                    sameProductCount: matchedProducts.length,
                    totalProductCount: order.productInfos.length || 0,
                    remainingCount: matchedProducts.reduce((sum, mp) => sum + mp.remaining, 0),
                    totalRemainingAll: totalRemainingAll,
                    currentProductNeedCount: matchedProducts[0].needCount || 0,
                    currentProductScannedCount: matchedProducts[0].scannedCount || 0,
                    sortPriority: sortPriority,
                    priorityText: priorityText
                });
            }

            // 排序
            this.recommendOrders = orderPriorities
                .sort((a, b) => {
                    // 先按优先级
                    if (a.sortPriority !== b.sortPriority) {
                        return a.sortPriority - b.sortPriority;
                    }
                    // 同优先级下，匹配商品剩余少的优先
                    if (a.remainingCount !== b.remainingCount) {
                        return a.remainingCount - b.remainingCount;
                    }
                    // 再按总剩余少的优先
                    return a.totalRemainingAll - b.totalRemainingAll;
                })
                .slice(0, 5);

        };

        // 更新扫描数量
        updateScanCount(record: ScanRecord, newCount: number) {
            if (newCount <= 0) {
                this.deleteScanRecord(record);
                return;
            }

            // 方法1: 使用展开运算符创建新数组，强制触发更新
            const index = this.scanRecords.findIndex(r => r.id === record.id);
            if (index !== -1) {
                // 创建新的记录对象
                const updatedRecord = {
                    ...record,
                    scanCount: newCount,
                    lastScanTime: new Date().toISOString()
                };

                // 创建新数组
                this.scanRecords = [
                    ...this.scanRecords.slice(0, index),
                    updatedRecord,
                    ...this.scanRecords.slice(index + 1)
                ];
            }

            // 立即重新计算推荐订单
            this.$nextTick(() => {
                this.calculateRecommendOrders();

                // 检查是否有订单可以打包
                const matchedOrder = this.findMatchOrder();
                if (matchedOrder) {
                    this.$Modal.confirm({
                        title: '订单已凑齐',
                        content: `订单 ${matchedOrder.orderNumber} 已凑齐，是否立即打包？`,
                        onOk: () => this.completeOrderPack(matchedOrder)
                    });
                }
            });
        }

        // 删除扫描记录
        deleteScanRecord(record: ScanRecord) {
            this.$Modal.confirm({
                title: '确认删除',
                content: '确定要删除这条扫描记录吗？',
                onOk: () => {
                    this.scanRecords = this.scanRecords.filter(r => r.id !== record.id);
                    this.calculateRecommendOrders();
                }
            });
        }

        // 清空所有扫描记录
        clearScanRecords() {
            this.$Modal.confirm({
                title: '确认清空',
                content: '确定要清空所有扫描记录吗？',
                onOk: () => {
                    this.scanRecords = [];
                    this.recommendOrders = [];
                    this.$Message.success('已清空扫描记录');
                }
            });
        }

        // 判断订单是否已凑齐
        isOrderComplete(order: any): boolean {
            if (!order.productInfos) return false;

            for (const product of order.productInfos) {
                const scanned = this.getProductScannedCount(product.productId);
                if (scanned < product.count) {
                    return false;
                }
            }
            return true;
        }

        // 完成订单打包
        async completeOrderPack(order: any) {
            const totalSkuCount = order.productInfos.reduce((sum: number, item: any) => {
                return sum + (item.count || 0);
            }, 0) || 0;

            //// 2. 再打印面单
            //var sucess = await this.printPdf(order);
            //if (!sucess) {
            //    return;
            //}


            // 1. 先调用打包接口
            await this.$store.dispatch({
                type: 'backstockorder/stockOrderBale',
                data: {
                    id: order.id,
                    SackNums: 0,
                    BaseSkuNums: totalSkuCount,
                    // packedUserId: this.$store.state.session.user?.id,
                    WarehouseReMark: ''
                }
            });



            // 3. 更新订单状态
            order.packageStatus = 4;
            order.packedTime = new Date();

            // 4. 移除该订单相关的扫描记录
            for (const product of order.productInfos || []) {
                const record = this.scanRecords.find(r => r.productId === product.productId);
                if (record) {
                    record.scanCount -= product.count;
                    if (record.scanCount <= 0) {
                        this.scanRecords = this.scanRecords.filter(r => r.id !== record.id);
                    }
                }
            }

            // 5. 重新排序订单列表
            this.orderList = [...this.orderList].sort((a: any, b: any) => {
                if (a.packedTime && !b.packedTime) return -1;
                if (!a.packedTime && b.packedTime) return 1;
                if (a.packedTime && b.packedTime) {
                    return new Date(b.packedTime).getTime() - new Date(a.packedTime).getTime();
                }
                return 0;
            });

            // 6. 更新统计数据
            this.packedCount = this.orderList.filter((o: any) => o.packageStatus === 4 || o.packageStatus ===2).length;
            this.unpackedCount = this.totalCount - this.packedCount;

            // 7. 重新计算推荐
            this.calculateRecommendOrders();

            this.$nextTick(() => {
                const table = this.$refs.selection as any;
                if (table) {
                    // 方法1：直接设置 scrollTop
                    if (table.$el) {
                        const tableBody = table.$el.querySelector('.ivu-table-body');
                        if (tableBody) {
                            tableBody.scrollTop = 0;
                        }
                    }

                    // 方法2：如果上面不行，尝试调用表格的内部方法
                    if (table.scrollTo) {
                        table.scrollTo(0, 0);
                    }

                    // 方法3：最直接的方法，找到所有可滚动的元素
                    if (table.$el) {
                        const scrollElements = table.$el.querySelectorAll('*');
                        scrollElements.forEach((el: any) => {
                            if (el.scrollHeight > el.clientHeight) {
                                el.scrollTop = 0;
                            }
                        });
                    }
                }
            });


            this.$Message.success('打包完成');

            await this.printPdf(order);
        }

        getPdfUrlDirect(data: any): string {
            if (!this.isPdfData) {
                return appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid +
                    "&id=" + (data.userId ? data.userId : abp.session.userId) +
                    "&orderNumber=" + data.orderNumber;
            } else {
                const infos = this.formatShelfData(data.productInfos);
                const heightPercentage = data.tradeNo.startsWith("68") ? 100 : 69;
                return appconst.remoteServiceBaseUrl + "api/File/GetZDYPdf?guid=" + data.pdfGuid +
                    "&userId=" + data.userId +
                    "&heightPercentage=" + heightPercentage +
                    "&infos=" + encodeURIComponent(infos);
            }
        }

        // 手动打包指定订单
        manualPackOrder(orderId: number) {
            const order = this.orderList.find(o => o.id === orderId);
            if (order) {
                if (this.isOrderComplete(order)) {
                    this.completeOrderPack(order);
                } else {
                    this.$Message.warning('该订单商品尚未扫齐');
                }
            }
        }

        // 标记异常
        markOrderAbnormal(order: any) {
            this.currentAbnormalOrder = order;
            var updateData = new UpdatebackstockorderStatu();
            updateData.id = order.id;
            updateData.orderStatus = -1;
            updateData.reMark = order.warehouseNote;
            updateData.orderNumber = order.orderNumber;
            this.$store.state.backstockorder.updateOrdeData = updateData;
            this.updateOderStatuShow = true;
        }

        // 异常处理成功
        handleAbnormalSuccess() {
            this.updateOderStatuShow = false;
            if (this.currentAbnormalOrder) {
                // 移除该订单相关的扫描记录
                for (const product of this.currentAbnormalOrder.productInfos || []) {
                    const record = this.scanRecords.find(r => r.productId === product.productId);
                    if (record) {
                        record.scanCount -= product.count;
                        if (record.scanCount <= 0) {
                            this.scanRecords = this.scanRecords.filter(r => r.id !== record.id);
                        }
                    }
                }
                this.calculateRecommendOrders();
                this.currentAbnormalOrder = null;
            }
            this.getOrderList();
        }

        // 打印面单
        async printOrderPdf(order: any) {
            await this.printPdf(order);
        }

        // 推荐行样式
        recommendRowClassName(row: any, index: number) {
            if (row.sortPriority === 1) {
                return 'recommend-row';
            }
            return '';
        }

        // 聚焦扫描输入框
        focusScanInput() {
            setTimeout(() => {
                const input = this.$refs.scanInput as any;
                if (input && input.focus) {
                    input.focus();
                }
            }, 100);
        }

        focusScanOrderInput() {
            setTimeout(() => {
                const input = this.$refs.scanOrderInput as any;
                if (input && input.focus) {
                    input.focus();
                }
            }, 100);
        }

        // 加载打印机列表
        async loadPrinterList() {
            try {
                var printWorld = new GetPrintWorld();
                var json = {
                    action: "printers",
                    refresh: true,
                    defaultprn: true,
                    error: "",
                    val: {}
                };

                printWorld.CallbackOnPrinterList((response: any) => {
                    if (response.val && response.val.length > 0) {
                        this.printerList = response.val.map((p: any) => p.name);
                    }
                    this.isLoadPrintList = true;
                });

                if (!printWorld.Act(json)) {
                    console.error('获取打印机列表失败');
                }
            } catch (error) {
                console.error('加载打印机失败', error);
            }
        }

        // 打印PDF
        async printPdf(data: any): Promise<boolean> {
            if (!this.selectedPrinter) {
                this.$Modal.warning({
                    title: '提示',
                    content: '请先选择打印机',
                    okText: '确定'
                });
                return false;
            }

            try {
                var pdfUrl = { url: null };
                pdfUrl.url = this.getPdfUrlDirect(data);

               // var pdfUrl = this.getPdfUrl(data);

                if (pdfUrl.url) {
                    var printWorld = new GetPrintWorld();
                    var jsons: any = {
                        action: "printfile",
                        format: "file_base64",
                        content: "",
                        printer: this.selectedPrinter,
                        paperlength: this.isPdfData ? 140 : 15,
                        paperwidth: this.isPdfData ? 100 : 10
                    };

                    // 获取PDF的Base64
                    const baseData = await this.pdfLinkToBase64(pdfUrl.url);
                    jsons.content = "data:application/pdf;base64," + baseData;

                    if (this.needCert) {
                        jsons.cert = "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf";
                    }

                    printWorld.Act(jsons);
                    return true;
                }
                return false;
            } catch (error) {
                console.error('打印失败', error);
                return false;
            }
        }

        // 获取PDF URL
        getPdfUrl(data: any): any {
            var pdfData: any = {};
            pdfData.pdfGuid = data.pdfGuid;
            pdfData.userId = data.userId;
            pdfData.orderNumber = data.orderNumber;
            pdfData.pdfdata = this.isPdfData;

            if (this.isPdfData) {
                pdfData.infos = this.formatShelfData(data.productInfos);
                if (data.tradeNo && data.tradeNo.startsWith("68")) {
                    pdfData.heightPercentage = 100;
                } else {
                    pdfData.heightPercentage = 69;
                }
            }

            this.$store.commit('fontorder/getZDYPdfUrl', pdfData);
            return pdfData;
        }

        // 格式化货架数据
        formatShelfData(data: any[]): string {
            if (!data || data.length === 0) return '';

            const totalCount = data.reduce((sum, item) => sum + item.count, 0);
            const formatTotal = (str: string) => str.padEnd(13, ' ');
            const formatShelf = (str: string) => str.padEnd(20, ' ');

            const shelfItems = data.map(item =>
                formatShelf(`${item.shelfPosition || ''}_${item.productId} * ${item.count > 1 ? `[${item.count}]` : item.count}`)
            );

            let output = [];

            if (shelfItems.length > 0) {
                let firstLine = formatTotal(`Total: ${totalCount}`);
                if (shelfItems.length >= 1) firstLine += shelfItems[0];
                if (shelfItems.length >= 2) firstLine += shelfItems[1];
                output.push(firstLine);
            }

            for (let i = 2; i < shelfItems.length; i += 2) {
                let line = ' '.repeat(17);
                if (shelfItems[i]) line += shelfItems[i];
                if (shelfItems[i + 1]) line += shelfItems[i + 1];
                output.push(line);
            }

            return output.join(',');
        }

        // PDF转Base64
        async pdfLinkToBase64(url: string): Promise<string> {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const arrayBuffer = await response.arrayBuffer();
                return this.arrayBufferToBase64(arrayBuffer);
            } catch (error) {
                console.error('Error fetching the PDF:', error);
                throw error;
            }
        }

        // ArrayBuffer转Base64
        arrayBufferToBase64(buffer: ArrayBuffer): string {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        }
    }
